import { CollegeSlider, TagList } from "../components/home";
import { registerWidget, DME, DMEData, generalSettings } from "dmeditor";
import { useEffect, useRef } from "react";

export interface TwitterEnitity {
  url: string;
  height?: number;
}

export const Twitter = (props: DME.WidgetRenderProps<TwitterEnitity>) => {
  const {
    blockNode: { data },
  } = props;
  const containerRef = useRef(null);

  const username = "TSSCollegeBound";

  useEffect(() => {
    // Check if Twitter widget script is already loaded
    const isScriptLoaded = document.querySelector(
      'script[src="https://platform.twitter.com/widgets.js"]'
    );

    // Function to create the timeline widget
    const createTimeline = () => {
      if (window.twttr && window.twttr.widgets) {
        window.twttr.widgets.createTimeline(
          {
            sourceType: "profile",
            screenName: username,
          },
          containerRef.current,
          {
            height: 600,
          }
        );
      }
    };

    if (!isScriptLoaded) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      script.onload = createTimeline;
      document.body.appendChild(script);
    } else {
      // Script already loaded — just call the widget creator
      createTimeline();
    }

    // Optional: cleanup on unmount
    return () => {
      if (containerRef.current) {
        (containerRef.current as any).innerHTML = "";
      }
    };
  }, [username]);

  return <div className="px-6" ref={containerRef}></div>;
};
